module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMtJREFUSA3tVYsNAiEMPcAxTudxEhgJxUEcSOcA28QmpWnsBe8SNZJc6Pe9awthmn52xRgbflaBVpy3AN71Ow6QUjq21i5gm7l9qeycu3nvU875SjldBQB+GgVHQMjf11rPBI57RwD6gTtHZCTheZKA+1aRNyfYab9ZSumGr8VoNu1Yb17BSwJ5iSxdq0oSDLVGAyabOgNyyllYOuXxXVbAfavIfwKzjd/fInlM71DzrF15sxfPAHwTeGzXohBCBCeSDC16cIaSPzbpARHrPNdXY18RAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Grey/date_grey.png
// module id = 661
// module chunks = 0